'use client';

import type { NextPage } from 'next';
import { MainContentWrapper } from '@/components/layout/MainContentWrapper/MainContentWrapper';
import { DefaultPageProps } from '@/types/types/page/pages';
import { useInitialPageLoad } from '@/hooks/general/useInitialPageLoad';
import { Error404 } from '@/components/blocks/errors/Error404';
import { usePageMetaData } from '@/hooks/general/usePageMetaData/usePageMetaData';
import { RESPONSE_ERROR_PHRASES } from '@/consts/phrases/errorPhrases';

const NotFoundPage: NextPage<DefaultPageProps> = ({ phrases, dictionary }) => {
    useInitialPageLoad({ phrases, countries: dictionary.countries });
    usePageMetaData({ pageTitlePhraseId: RESPONSE_ERROR_PHRASES.PAGE_NOT_FOUND });

    return (
        <MainContentWrapper phrases={phrases} dictionary={dictionary} className="page-404">
            <Error404 />
        </MainContentWrapper>
    );
};

export default NotFoundPage;
